module.exports = __webpack_public_path__ + "static/media/pumps.4b68df1a.jpeg";